var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var DfnPadGeneratorInteractionModel = require('./dfnPadGeneratorInteractionModel.js');
var PackageGeneratorInspectorConfig = require("../../packageGeneratorInspectorConfig.js");
var IpcImages = require("../../../../../shared/extensions/footprintGenerator/ipcImages/index.js");

var Dfn4PadGeneratorInteractionModel = function(parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
    DfnPadGeneratorInteractionModel.call(this, parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams);
};

lib_core.inherit(Dfn4PadGeneratorInteractionModel, DfnPadGeneratorInteractionModel);
Dfn4PadGeneratorInteractionModel.$class = 'Dfn4PadGeneratorInteractionModel';
module.exports = Dfn4PadGeneratorInteractionModel;

Dfn4PadGeneratorInteractionModel.prototype.getInspectorElementForPitch = function() {
    var rowPitch = PackageGeneratorInspectorConfig.getValueFixedUnit('d', this.LCLZ('hPinPitch', 'Horizontal Pin Pitch'), this.horizontalPinPitch, this.userSettingsModel.distanceUnit);
    var colPitch = PackageGeneratorInspectorConfig.getValueFixedUnit('e', this.LCLZ('vPinPitch', 'Vertical Pin Pitch'), this.verticalPinPitch, this.userSettingsModel.distanceUnit);

    return [rowPitch, colPitch];
};

Dfn4PadGeneratorInteractionModel.prototype.componentFamilyList = function() {
    var FamilyList = [];

    for (var t in cio_datamodel.IpcDataModel.ComponentAttribute.dfnComponentFamily.DFN_34) {
        var c = cio_datamodel.IpcDataModel.ComponentAttribute.dfnComponentFamily.DFN_34[t];
        FamilyList.push([this.LCLZ(t, c), c]);
    }
    return FamilyList;
};

Dfn4PadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    if (this.withCustomFootprintParams() && this.showFootprintParams()) {
        imElements = imElements.concat(this.getInspectorElementForEnablingCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintImage(IpcImages.customFootprintDfn4));
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintNormalPadSettings());
        imElements = imElements.concat(this.getInspectorElementForPadGapInCustomFootprint());

    };
    imElements = imElements.concat(this.getInspectorElementForComponentFamily());
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForPitch());
    imElements = imElements.concat(this.getInspectorElementForTerminalLength());
    imElements = imElements.concat(this.getInspectorElementForTerminalWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForTolerance());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
}